import styled from 'styled-components';

import { fontFamilySize, px } from '../../../../contrib/ui';

export const StyledSelectCTPWinner = styled.div`
  .paper.someone-closer-than {
    display: flex;
    flex-direction: column;
    align-items: center;

    h3 {
      text-align: center;
      ${fontFamilySize('Heavy', 18)}
    }

    .scorer-data,
    .distance {
      margin-bottom: ${px(15)};
    }

    .distance {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      .number-container {
        background-color: var(--greyf9);
        border-radius: ${px(5)};
        box-shadow: 0 ${px(2)} ${px(4)} 0 rgba(216, 216, 216, 0.5);

        padding: ${px(5)} ${px(10)};
        margin-right: ${px(10)};
        height: ${px(40)};

        span {
          ${fontFamilySize('Heavy', 30)}
          color: var(--grey59);
        }
      }

      .unit {
        ${fontFamilySize('Bold', 16)}
        color: var(--dark);
        margin-right: ${px(10)};
      }
    }
  }

  .enter-scores-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    h3 {
      ${fontFamilySize('Heavy', 15)}
    }

    .enter-scores-button {
      width: fit-content;
      color: var(--mainColor);
      span {
        svg {
          font-size: ${px(25)};
          margin-left: 0;
        }
      }
    }
  }
`;
